//@flow
import * as Immutable from 'immutable';

import { Amount } from 'common/models/flow/Amount';
import type { AmountModelType } from 'common/models/flow/Amount';
import {
    validatable,
    validate,
    validateAll,
    softValidateAll
} from 'common/utils/ValidationUtil';
import getSymbolFromCurrency from 'currency-symbol-map';
import NumberUtils from 'common/utils/NumberUtils';
import DataUtils from 'common/utils/DataUtils';
import I18nHelper from 'common/helpers/I18nHelper';

const translationsNamespace = ['validations'];
const nsTranslate = I18nHelper.getTranslate(translationsNamespace);

@validatable
class InternalAmount extends Amount {
    static fromJS(json: AmountModelType): InternalAmount {
        const state: Object = Object.assign({}, json);
        state.costContribution = state.costContribution
            ? Immutable.Map(state.costContribution)
            : state.costContribution;
        return new this(Immutable.Map(state));
    }

    getCurrencySymbol(): string {
        return this.symbol || `${this.currency}${'\u00A0'}`;
    }

    getCurrencyString(): string {
        return `${this.symbol || this.currency} ${this.amount}`;
    }

    @softValidateAll
    hasValidationErrors(): boolean {
        return false;
    }

    @validateAll
    setAllValidationErrors(): this {
        return this;
    }

    @validate
    setAmount(amount: ?number) {
        return super.setAmount(amount);
    }

    validateAmount() {
        if (
            !DataUtils.isEmpty(this.amount) &&
            !NumberUtils.isNonNegativeNumber(this.amount)
        ) {
            return nsTranslate('amountNotAPositiveNumber');
        }
    }

    static defaultInit({ props }): InternalAmount {
        const { defaultCurrency } = props;
        return InternalAmount.fromJS({
            amount: null,
            symbol: getSymbolFromCurrency(defaultCurrency),
            currency: defaultCurrency
        });
    }
}

export { InternalAmount as Amount };
